import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type { ParamsFifaBurialPoint } from './types.ts';
/**
 * 埋点 top up/金币 查看offer列表页的时候点击view more的时候记录一下操作
 */

export const viewMoreBurialPoint = (query: { spuId?: string }): AxiosPromise<true> => {
  return request({
    url: '/product/urlMapping/game-service/viewMoreBurialPoint',
    method: 'get',
    params: query
  });
};
/**
 * fifa金币包埋点
 */

export const fifaBurialPoint = (data: ParamsFifaBurialPoint): AxiosPromise<true> => {
  return request({
    url: '/product/api/fifa/game/burialPoint',
    method: 'post',
    data
  });
};
